// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1CKgJ","alertIcon":"ConfirmModal_alertIcon__1gAb9"};